var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"no-course-modal","size":"lg","hide-header":"","hide-footer":"","centered":"","modal-class":"no-course-modal text-center"}},[_c('p',[_c('b',[_vm._v("Course Not Started Yet!")]),_c('br'),_vm._v("\n    You Will get notification when the course starts if you subscribe the\n    course\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }